<template>
  <div>
    <v-footer color="#B40000" class="footer-padding footer-custom">
      <v-container fluid>
        <v-row class="justify-space-between">
          <!-- col 1 principal -->
          <v-col cols="auto" class="align-self-center">
            <v-row class="text-white">
              <v-col cols="12" class="align-self-center pa-0">
                <router-link to="/">
                  <v-img
                    src="@/assets/logos/Logo-martinez-horizontal-blanco.png"
                    class="footer-logo-white"
                  ></v-img>
                </router-link>

                <div class="d-sm-none footer-padding-custom-ubication">
                  <span>
                    Calle 15 de Mayo No. 1410 Pte.
                    <br />Monterrey, Nuevo León
                    <br />CP.64000
                    <br />
                    <a href="tel:183432000" target="_blank" class="white--text">Tel. 18.343.2000</a>
                    <br />
                    <div class="d-flex">
                      <div>
                        <a
                          href="https://api.whatsapp.com/send?phone=8180201878&text=Esto%20es%20una%20prueba."
                          target="_blank"
                        >
                          <v-img src="@/assets/svg/whatsapp.svg" class="d-inline-block" width="18"></v-img>
                        </a>
                      </div>
                      <div class="pl-1">
                        <a
                          href="https://api.whatsapp.com/send?phone=8180201878&text=Esto%20es%20una%20prueba."
                          target="_blank"
                          class="white--text"
                        >8180201878</a>
                      </div>
                    </div>
                  </span>
                </div>
              </v-col>
              <v-col cols="auto" class="ml-auto d-sm-none">
                <v-img src="@/assets/png/firma.png" width="55"></v-img>
              </v-col>
            </v-row>
          </v-col>
          <!-- /col 1 principal -->

          <!-- col 2 principal -->
          <v-col cols="auto" class="align-self-center pa-0">
            <v-row>
              <v-col cols="auto" class="align-self-center d-none d-sm-block">
                <v-img src="@/assets/png/firma.png" width="100"></v-img>
              </v-col>
              <v-col
                cols="auto"
                class="text-white align-self-center d-none d-sm-block"
                style="line-height: 1.2;"
              >
                <div>
                  <span>
                    Calle 15 de Mayo No. 1410 Pte.
                    <br />Monterrey, Nuevo León
                    <br />CP.64000
                    <br />
                    <a href="tel:183432000" target="_blank" class="white--text">Tel. 18.343.2000</a>
                    <br />
                    <div class="d-flex">
                      <div>
                        <a
                          href="https://api.whatsapp.com/send?phone=8180201878&text=Esto%20es%20una%20prueba."
                          target="_blank"
                        >
                          <v-img src="@/assets/svg/whatsapp.svg" class="d-inline-block" width="18"></v-img>
                        </a>
                      </div>
                      <div class="pl-1">
                        <a
                          href="https://api.whatsapp.com/send?phone=8180201878&text=Esto%20es%20una%20prueba."
                          target="_blank"
                          class="white--text"
                        >8180201878</a>
                      </div>
                    </div>
                  </span>
                </div>
                <div>
                  <div>
                    <ul class="pl-0 mt-3 d-flex socialIcons">
                      <li>
                        <a
                          href="https://www.facebook.com/Martinez-Lozano-y-Asociados-Contadores-P%C3%BAblicos-SC-108434833831743"
                          target="_blank"
                        >
                          <v-img src="@/assets/png/fb.png" class="facebook-icon footer-icons"></v-img>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/mlcp.mx/" target="_blank">
                          <v-img
                            src="@/assets/png/instagram.png"
                            class="instagram-icon footer-icons"
                          ></v-img>
                        </a>
                      </li>
                      <!-- <li>
                        <router-link to="/">
                          <v-img src="@/assets/png/tw.png" class="twitter-icon footer-icons"></v-img>
                        </router-link>
                      </li>
                      <li>
                        <router-link to="/">
                          <v-img src="@/assets/png/yt.png" class="youtube-icon footer-icons"></v-img>
                        </router-link>
                      </li>
                      <li>
                        <router-link to="/">
                          <v-img src="@/assets/png/blogger.png" class="blogger-icon footer-icons"></v-img>
                        </router-link>
                      </li>-->
                    </ul>
                  </div>
                </div>
              </v-col>

              <!-- <v-col cols="10">
                <div>
                  <ul class="pl-0 d-flex socialIcons">
                    <li>
                      <router-link to="/">
                        <v-img src="@/assets/png/fb.png" width="25"></v-img>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/">
                        <v-img src="@/assets/png/tw.png" width="25"></v-img>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/">
                        <v-img src="@/assets/png/yt.png" width="30"></v-img>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/">
                        <v-img src="@/assets/png/blogger.png" width="25"></v-img>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </v-col>-->
            </v-row>
          </v-col>
          <!-- /col 2 principal -->
        </v-row>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
export default {};
</script>